import Vue from 'vue'
import VueResource from 'vue-resource'
import store from '../store'

import ContactService from './ContactService'
import UserService from './UserService'
import RefusesService from './RefusesService'
import OperadorasService from './OperadorasService'
import ScheduleService from './ScheduleService'
import VonixPabxService from './VonixPabxService'
import UtilsService from './UtilsService'
import PropostaService from './PropostaService'
import BilhetagemService from './BilhetagemService'
import CallidLogService from './CallidLogService'
import ProductsService from './ProductsService'
import VendaService from './VendaService'
import PaymentService from './PaymentService'
import MailService from './MailService'
import RetencaoOnline from './RetencaoOnline'

Vue.use(VueResource)
let VueHttp = new Vue({
  store
})

Vue.http.interceptors.push((request, next) => {
  next((response) => {
    if (response.status === 401) {
      store.commit('removeAllContacts', [])
      store.commit('setUser', {})
      window.location.reload()
    }
  })
})

let callidLogService = new CallidLogService(VueHttp)
let bilhetagemService = new BilhetagemService(VueHttp)
let vonixPabxService = new VonixPabxService(store.state.pabx.url)
let contactService = new ContactService(VueHttp)
let userService = new UserService(VueHttp)
let refusesService = new RefusesService(VueHttp)
let operadorasService = new OperadorasService(VueHttp)
let scheduleService = new ScheduleService(VueHttp)
let propostaService = new PropostaService(VueHttp)
let productsService = new ProductsService(VueHttp)
let vendaService = new VendaService(VueHttp)
let paymentService = new PaymentService(VueHttp)

let utilsService = new UtilsService(VueHttp)
let mailService = new MailService(VueHttp)

const retencaoOnline = new RetencaoOnline(VueHttp)

export {
  contactService,
  refusesService,
  operadorasService,
  userService,
  scheduleService,
  vonixPabxService,
  utilsService,
  propostaService,
  bilhetagemService,
  callidLogService,
  productsService,
  vendaService,
  paymentService,
  mailService,
  retencaoOnline
}



// WEBPACK FOOTER //
// ./src/service/index.js